var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        _vm._b(
          { ref: "formRef", attrs: { model: _vm.form, rules: _vm.rules } },
          "el-form",
          _vm.formConfig,
          false
        ),
        [
          _c(
            "el-form-item",
            { attrs: { label: "商品标签：" } },
            [
              _c(
                "el-checkbox-group",
                {
                  model: {
                    value: _vm.form.labelId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "labelId", $$v)
                    },
                    expression: "form.labelId",
                  },
                },
                _vm._l(_vm.comData.goodsLabelEnum, function (item) {
                  return _c(
                    "el-checkbox",
                    { key: item.id, attrs: { label: item.id } },
                    [
                      _vm._v(
                        "\n          " + _vm._s(item.labelName) + "\n        "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "排序：" } },
            [
              _c("el-input-number", {
                attrs: {
                  step: 1,
                  min: 0,
                  placeholder: "请输入排序",
                  "controls-position": "right",
                },
                model: {
                  value: _vm.form.sort,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "sort", $$v)
                  },
                  expression: "form.sort",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "同步分销授权：", prop: "customerId" } },
            [
              _c(
                "el-table",
                {
                  ref: "customersListTableRef",
                  attrs: { data: _vm.comData.customersList },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", align: "center" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "分销商名称" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }